<template>
  <component :is="layoutComponent" />
</template>

<script>
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import NoLayout from "@/layouts/NoLayout.vue";

export default {
  name: "App",
  components: {
    DefaultLayout,
    NoLayout,
  },
  computed: {
    layoutComponent() {
      // Exemple : Utiliser le nom de la route pour choisir le layout
      if (this.$route.name === "register" || this.$route.name === "setup-company" || this.$route.name === "login" || this.$route.name === "forgot-password" || this.$route.name === "catalog") {
        return NoLayout;
      }
      return DefaultLayout;
    },
  },
};
</script>

<style type="text/css">
  .btn {
    text-transform: none !important;
  }
</style>
